function format (level, color, context, ...args) {
	if (color === 'main') {
		color = '#00a2ac'
	}
	return [
		`%c${context}`,
		`background:${color};color:#fff;padding: 2px 0.5em;border-radius: 0.5em;`,
		...args
	]
}

export function print (level, color, context, ...args) {
	if (typeof(console) !== 'undefined' && process.env.NODE_ENV === 'development') {
		return console[level].bind(window.console, ...format(level, color, context, ...args))
	} else {
		return function () {} // Return empty function
	}
}

export function log (...args) {
	if (typeof(console) !== 'undefined' && process.env.NODE_ENV === 'development') {
		console.log(...args)
	}
}

export default {
	log (context, ...args) {
		return print('log', 'gray', context, ...args)
	},
	info (context, ...args) {
		return print('info', 'green', context, ...args)
	},
	warn (context, ...args) {
		return print('warn', 'orange', context, ...args)
	},
	error (context, ...args) {
		return print('error', 'red', context, ...args)
	}
}



// WEBPACK FOOTER //
// ./src/utils/consolelog.js